import React from "react";

import { Box } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import { FiTrash2 } from "react-icons/fi";

import { useAppState } from "../../../../../context/StateContext";
import { Color } from "../../../../Form/Button";
import { GroupedButtons } from "../../../../Generic/GroupedButtons";
import { OrderTabs } from "../../../utils";
import useStyles from "./styles";

interface Props {
  onSave: () => void;
  onCancel: () => void;
  loading?: boolean;
  viewOnly?: boolean;
  id?: number;
  showModal: (value: boolean) => void;
  leftPanelSelected: string;
}

const OrderActionButtons = (props: Props) => {
  const { loading, onSave, onCancel, viewOnly, id, showModal, leftPanelSelected } = props;
  const { isSupplierPortal, currentUser } = useAppState();
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection={"row"}
      justifyContent={"flex-end"}
      className={classes.buttons}
    >
      <GroupedButtons
        buttons={[
          {
            name: "delete",
            action:
              leftPanelSelected === OrderTabs.DETAILS && currentUser?.isAdmin && id
                ? () => showModal(true)
                : undefined,
            disabled: loading || isSupplierPortal || viewOnly,
            loading,
            dataCy: "delete-order-button",
            customColor: Color.ERROR,
            children: (
              <Stack
                alignItems="center"
                justifyContent="center"
                width="100%"
                direction="row"
                spacing={1}
              >
                <FiTrash2 />
                <span>{translate("delete")}</span>
              </Stack>
            ),
          },
          {
            name: "cancel",
            action: onCancel,
            disabled: loading,
            variant: "text",
            customColor: Color.CANCEL,
            text: translate("cancel"),
          },
          {
            name: "save",
            action: onSave,
            disabled: viewOnly,
            loading,
            customColor: Color.SUCCESS,
            text: !id ? translate("create") : translate("save"),
          },
        ]}
      ></GroupedButtons>
    </Box>
  );
};

export default OrderActionButtons;
